import React, { useState, useEffect } from "react"
import { Typography } from "antd"
import { Animated } from "react-animated-css"
import { Link } from "gatsby"
import { useRecoilState } from "recoil"
import counterState from "../services/counterAtom"
import UserInfoModal from "./UserInfoModal"

const textArray = [
  ["Helping SMEs Harness the Power of AI for Unmatched Growth"],
]

const subTextArray = [
  [
    "We design AI-Native platforms, AI-Powered SaaS products, custom integrations, and Odoo implementation — engineered by expert team who stay on every engagement from first call to final handover."
  ],
]

const backgroundColorsArray = [
  { fontColor: "#ffffff" },
  { fontColor: "#ffffff" },
  { fontColor: "#ffffff" },
  { fontColor: "#ffffff" },
  { fontColor: "#ffffff" },
]

const getArtWorkStyles = [
  { marginTop: "18vh" },
  { transform: "scale(1.6)", marginTop: "20vh" },
  { marginTop: "15vh" },
  {},
  {},
]

const HomePageIntro = ({ data }) => {
  const [isVisible, setIsVisible] = useState(true)
  const [count, setCount] = useRecoilState(counterState)
  const [auditModalOpen, setAuditModalOpen] = useState(false)
  const { Title } = Typography

  useEffect(() => {
    const interval = setInterval(() => setIsVisible(false), 6000)
    const secondInterval = setInterval(() => {
      if (count < 3) {
        setCount(count + 1)
      } else {
        setCount(0)
      }
      setIsVisible(true)
    }, 6300)
    return () => {
      clearInterval(interval)
      clearInterval(secondInterval)
    }
  }, [count, setCount])

  return (
    <Animated
      className="text-and-image-container"
      style={{ position: "relative", zIndex: 0, objectFit: "cover" }}
    >
      {/* Background gradient — always fills the container */}
      <div className="hero-gradient" />

      {/* Decorative artwork — absolute, desktop only */}
      <div
        className={`art-work ${count === 1 ? "second-artwork" : ""}`}
        style={getArtWorkStyles[count]}
      />

      {/* Content — drives height on mobile */}
      <div className="animated-div">
        <Title
          style={{ color: backgroundColorsArray[count].fontColor }}
          className="title"
        >
          {textArray[0]}
        </Title>
        <p
          style={{
            color: backgroundColorsArray[count].fontColor,
            marginBottom: "9px",
            textAlign: "center",
          }}
          className="peragraph"
        >
          {subTextArray[0]}
        </p>

        <div style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "16px", marginTop: "24px", flexWrap: "wrap" }}>
          <Link to="/contact">
            <button className="header-button-new">Book Your Free Consultation Now</button>
          </Link>
          <button
            className="header-button-new"
            style={{ backgroundColor: "#2ae66f" }}
            onClick={() => setAuditModalOpen(true)}
          >
            AI Audit Your Organization for Free!
          </button>
        </div>

        <div className="hero-stats">
          <div className="hero-stat-item">
            <span className="hero-stat-number">50+</span>
            <span className="hero-stat-label">Projects Delivered</span>
          </div>
          <div className="hero-stat-item">
            <span className="hero-stat-number">4</span>
            <span className="hero-stat-label">Continents Served</span>
          </div>
          <div className="hero-stat-item">
            <span className="hero-stat-number">
              {(230400 + Math.floor((Date.now() - new Date("2026-05-05").getTime()) / 86400000) * 160).toLocaleString()}
            </span>
            <span className="hero-stat-label">Development Hours</span>
          </div>
        </div>
      </div>
      <UserInfoModal open={auditModalOpen} onClose={() => setAuditModalOpen(false)} />
    </Animated>
  )
}

export default HomePageIntro
